import { formatName } from '@pickleballinc/lib/format-name';
import { Avatar } from '@pickleballinc/ui/components/ui/avatar';

import ImageWithFallback from '@/components/atoms/ImageWithFallback';
import { TeamInfo } from '@/entities/TeamLeagueTeamInfo';
import { TeamLeagueTeamsInfo } from '@/entities/TeamLeagueTeamsInfo';
import { determinePlayerPhotoForPlayerMovesUrl } from '@/lib/helper';
import { TeamPlayerInfo } from '@/lib/types';

interface StepFourProps {
	currentTeamDroppedPlayers: TeamPlayerInfo[];
	currentTeam: TeamInfo;
	selectedTeam?: TeamLeagueTeamsInfo;
	otherTeamDroppedPlayers: TeamPlayerInfo[];
}

export function StepFour({ otherTeamDroppedPlayers, currentTeamDroppedPlayers, currentTeam, selectedTeam }: StepFourProps) {
	return (
		<div className="mx-12 mt-20 flex flex-col items-center gap-6 rounded-lg bg-violet-25 p-9 text-center text-gray-900">
			<p className="text-sm font-medium text-gray-500">You are about to initiate the following trade.</p>

			<div className="flex items-center gap-2">
				<ImageWithFallback
					src={currentTeam.logo ? currentTeam.logo.url : '/assets/images/placeholder.png'}
					alt={currentTeam.title}
					fallbackSrc="/assets/images/placeholder.png"
					className={`rounded object-cover`}
					width={80}
					height={40}
				/>
				<p className="text-2xl font-semibold">{currentTeam.title}</p>
			</div>
			<p className="text-lg font-semibold">offers</p>

			{currentTeamDroppedPlayers.map((player) => (
				<div key={player.uuid} className="flex items-center gap-4  text-lg font-semibold text-gray-900">
					<Avatar
						firstName={player.firstName}
						lastName={player.lastName}
						src={determinePlayerPhotoForPlayerMovesUrl(player.photo)}
						className="border border-orange-500"
						variant="lightGray"
						size="sm"
					/>
					<p>{formatName({ firstName: player.firstName, lastName: player.lastName })}</p>
				</div>
			))}
			<p className="text-lg font-semibold">to</p>
			{selectedTeam ? (
				<div className="flex items-center gap-2">
					<ImageWithFallback
						src={selectedTeam.logo ? selectedTeam.logo.url : '/assets/images/placeholder.png'}
						alt={selectedTeam.title}
						fallbackSrc="/assets/images/placeholder.png"
						className={`rounded object-cover`}
						width={80}
						height={40}
					/>
					<p className="text-2xl font-semibold">{selectedTeam.title}</p>
				</div>
			) : null}
			<p className="text-lg font-semibold">for</p>
			{otherTeamDroppedPlayers.map((player) => (
				<div key={player.uuid} className="flex items-center gap-4  text-lg font-semibold text-gray-900">
					<Avatar
						firstName={player.firstName}
						lastName={player.lastName}
						src={determinePlayerPhotoForPlayerMovesUrl(player.photo)}
						className="border border-orange-500"
						variant="lightGray"
						size="sm"
					/>
					<p>{formatName({ firstName: player.firstName, lastName: player.lastName })}</p>
				</div>
			))}
		</div>
	);
}
